<template>
  <div class="home-container">
    <div class="home-content">

      <div style="margin: 20px">
        <el-button
          size="small"
          type="primary"
          style="width: 90px; margin-right: 15px; margin-bottom: 15px"
          icon="el-icon-download"
          @click="downloadUrl"
        >
          导出</el-button
        >
        <el-button size="small" type="primary" @click="back" style="width: 90px"
          >返回</el-button
        >
      </div>
      <el-table
        :data="tableData"
        style="width: 100%"
        border
        v-loading="isShowloading"
      >
        <el-table-column prop="userName" label="维护人" align="center">
        </el-table-column>
        <el-table-column prop="phone" label="手机号码" align="center">
        </el-table-column>
        <el-table-column
          prop="deviceUpholdName"
          label="设备名称"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="img" label="维护图片" align="center">
          <template slot-scope="scope">
            <img
              :src="scope.row.img ? scope.row.img.split(',')[0] : ''"
              style="cursor: pointer"
              min-width="70"
              height="70"
              v-viewer
            />
          </template>
        </el-table-column>
        <el-table-column prop="des" label="维护内容" align="center">
        </el-table-column>
        <el-table-column prop="createTime" label="维护时间" align="center">
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <div class="block" style="margin-top: 15px">
        <el-pagination
          align="center"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    seeId: Number,
    equipmentName: String,
  },
  data() {
    return {
      searchForm: {
        name: "",
      },
      currentPage: 1, // 当前页码
      total: 10, // 总条数
      pageSize: 10, // 每页的数据条数
      tableData: [],
      isShowloading: false,
      baseUrL: "https://szwy.zjwsrc.com/admin/device-uphold-record/list-export",
    };
  },
  methods: {
    // 导出
    downloadUrl() {
      var villageId = JSON.parse(localStorage.getItem("park_data")).id;
      window.location.href =
        this.baseUrL +
        "?villageId=" +
        villageId +
        "&deviceUpholdId=" +
        this.seeId +
        "&name=" +
        this.equipmentName; //文件路径
    },
    onLoad() {
      this.isShowloading = true;
      let page = {
        current: this.currentPage,
        size: this.pageSize,
        deviceUpholdId: this.seeId,
        name: this.searchForm.name,
      };
      this.$Apis.deviceUpholdRecordList(page).then((res) => {
        this.isShowloading = false;
        if (res.code == 200) {
          let { current, list, pages, total } = res.data;
          this.currentPage = current;
          this.size = pages;
          this.total = total;
          this.tableData = list;
        }
      });
    },
    // 重置按钮
    restSearch() {
      for (let item in this.searchForm) {
        this.searchForm[item] = "";
      }
      this.onLoad();
    },
    // 返回
    back() {
      this.$emit("back", false);
    },
    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.onLoad();
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.onLoad();
    },
  },
  mounted() {
    this.onLoad();
  },
};
</script>

<style>
.home-container {
  padding: 10px;
  padding-top: 5px;
}
.home-content {
  padding: 10px;
  border-radius: 5px;
  background: #fff;
}
.tree {
  margin-top: 10px;
  width: 300px;
  z-index: 999;
  background-color: #fff;
  padding: 20px;
  height: 200px;
  overflow: auto;
  border: 1px solid #eee;
  border-radius: 5px;
}
#app-container {
  text-align: center;
}
</style>